// extracted by mini-css-extract-plugin
export default {"errorMessage":"AuthErrorMessage-module__errorMessage_W81kf","warningMessage":"AuthErrorMessage-module__warningMessage_q67D3"};